<template>
    <div  :class="['padding_bottom_64',{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}]">
        <div class="margin_top_100">
            <!-- <div style="height:320px;background-color:#eee;line-height:320px;font-size:50px">BANNER</div> -->
            <banner :list="bannerdata"></banner>
        </div>
        <div class="rank_contain">
            <div class="padding-32" >
                <div class="inline-block rank_menu" v-for="(item,index) in rankArr" @click="tapchoose(item)" v-if="currentlang !=='eng'">
                    <img :src="currenttap == item.type ?item.iconActive:item.icon" class="vertical-middle margin_right_8">
                    <span class="vertical-middle" :class="{'tapactivecolor':currenttap == item.type}">{{item.title}}</span>
                </div>
                <div class="inline-block rank_menu" v-for="(item,index) in rankArrEn" @click="tapchoose(item)" v-if="currentlang =='eng'">
                    <img :src="currenttap == item.type ?item.iconActive:item.icon" class="vertical-middle margin_right_8">
                    <span class="vertical-middle" :class="{'tapactivecolor':currenttap == item.type}">{{item.title}}</span>
                </div>
            </div>
            <div>
                <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;"  v-for="item in reportdata" v-if="currenttap == 'report'"  @click="todetail('report',item)">
                    <div class="rank_reportL">
                        <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                        <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                            <div>
                                <div class="title_limit2 line2">{{item.title}}</div>
                                <div class="report_content">{{item.summary}}</div>
                            </div>
                            <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                        </div>
                    </div>
                    <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePc +')'}">
                        <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                    </div>
                </div>
                <div style="padding-bottom:40px;">
                    <div class="position_relative display_flex   flex-wrap_wrap"  v-if="currenttap == 'rank'">
                        <div class="rankitem" v-for="item in rankdata" @click="todetail('rank',item)">
                            <div class="coveritem" :style="{backgroundImage:'url('+ item.listImage +')'}">
                                <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                                <!-- <img src="../../assets/images/1.png"> -->
                            </div>
                            <div class="sec_name"><span>{{item.title}}</span> <span v-if="item.rankingType == '3'">{{item.subTitle}}</span></div>
                            <div class="date display_flex justify-content_flex-justify">
                                <div>{{formatTimefun(item.publishTime)}}</div>
                                <span class="arr_class"></span>
                                <!-- <img src="../../assets/images/rang.png" width="16" height="16"> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="textalign_center padding_40" v-if="isLoading">
                    <img src="https://p1.fishqc.net/Fho2IJV-sxzRgCKm6V_dovGJ8xIM" class="">
                </div>
                <div class="textalign_center padding_40" v-if="data_end_flag">
                    
                    <div> ~ {{$t('common.bottom')}} ~</div>
                </div>
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.margin_top_100{
    margin-top: 100px;
}
.padding-32{
    padding:32px 0;
}
.rank_contain{
    width: 1200px;
    margin:0 auto;
}
.rank_menu{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A8A8AD;
    line-height: 32px;
    cursor: pointer;
    &:nth-of-type(2){
        margin-left:40px;
    }
}
.margin_right_8{
    margin-right: 8px;
}


</style>

<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import {getranklistApi,getreportlistApi,getBannerApi} from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import Modal from '@/components/Modal.vue'
import {formatTime} from '@/utils/other.js'
import { getCookie } from '@/utils/cookieUtil'
export default {
    name: '',
    components: {
        banner,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            rankArr:[
                {
                    title:this.$t('index.reportTitle'),
                    type:'report',
                    icon:'http://p1.fishqc.net/FplyuZFQihZEE6uKxYo1M_u18Hvr',
                    iconActive:'http://p1.fishqc.net/Fsn9dxNpktTOmlI7uQmkV1pnR5YR'
                },
                {
                    title:this.$t('index.rankTitle'),
                    type:'rank',
                    icon:'http://p1.fishqc.net/Fj5RwfpF8gahwKn63asYJkiDHZoS',
                    iconActive:'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                }

            ],
            rankArrEn:[
                // {
                //     title:this.$t('index.reportTitle'),
                //     type:'report',
                //     icon:'http://p1.fishqc.net/FplyuZFQihZEE6uKxYo1M_u18Hvr',
                //     iconActive:'http://p1.fishqc.net/Fsn9dxNpktTOmlI7uQmkV1pnR5YR'
                // },
                {
                    title:this.$t('index.rankTitle'),
                    type:'rank',
                    icon:'http://p1.fishqc.net/Fj5RwfpF8gahwKn63asYJkiDHZoS',
                    iconActive:'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                }

            ],
            currenttap:'report',
            rankdata:[],
            reportdata:[],
            currentpage:1,
            bannerdata:[],
            data_end_flag:false,
            isLoading:false,
            totalpage:0,
            ismodalshow:false,
            langdesc:{
                free:this.$t('index.free'),
                bought:this.$t('rankindex.bought')

            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y/M/D')
            }
        }
    },
    mounted() {
        console.log(this.$route.query.type)
        this.currentlang = window.localStorage.getItem("LOCALE")
        if(window.localStorage.getItem("LOCALE") == 'eng'){

            this.currenttap = 'rank'
        }
        this.getbanner()
        if(this.$route.query.type == 'report'){
            this.currenttap = 'report'
            this.getreportlist()
            
        }else{
            this.currenttap = 'rank'
            this.getranklist()
        }
        window.addEventListener("scroll",this.throttle(this.handleScroll,500),true)
        
    },
    methods: {
        tapchoose(item){
            this.currenttap = item.type

            this.currentpage = 1
            this.rankdata = []
            this.reportdata = []
            this.totalpage = 0
            this.data_end_flag = false
            // this.isLoading = false

            if(item.type == 'rank'){
                this.getranklist()
            }else{
                this.getreportlist()
            }
        },
        getranklist(){

            if(this.isLoading){
                return
            }

            if(this.data_end_flag){  
                return
            }

            this.isLoading = true

            getranklistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:8
            }).then(res => {
                console.log(res)
                this.isLoading = false
                if (res.code == 200) {
                    this.rankdata = this.rankdata.concat(res.data.list)
                    this.totalpage = res.data.totalpage
                    if(this.currentpage >= res.data.totalpage){
                        this.data_end_flag = true;
                    }


                } else {
                    this.toast(res.message)

                }
            })
        },
        getreportlist(){

            if(this.isLoading){
                return
            }

            if(this.data_end_flag){  
                return
            }

            this.isLoading = true

            getreportlistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:4
            }).then(res => {
                console.log(res)
                this.isLoading = false
                if (res.code == 200) {
                    this.reportdata = this.reportdata.concat(res.data.list)
                    this.totalpage = res.data.totalpage
                    if(this.currentpage >= res.data.totalpage){
                        this.data_end_flag = true;
                    }
                } else {
                    this.toast(res.message) 

                }
            })
        },
        getbanner(){
            getBannerApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.bannerdata = res.data.list
                } else {
                    // this.toast(res.message)

                }
            })
        },
        todetail(type,item){
            // if(item.buyStatus){
            //     this.toast('请勿重复购买！')
            //     return
            // }
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.reportUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    if(getCookie('fqcU')){
                        if(item.buyStatus){  //已购买榜单，进入详情
                            if(item.rankingType == '3'){
                                if(item.urlPc){
                                    window.location.href = item.urlPc
                                }
                            }else{
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }
                        }else{
                            this.ismodalshow = true
                            this.$refs.modaltoast.show({
                                type:'guide',
                                itemtype:'1',    //榜单
                                itemdata:item
                            });
                        }
                    }else{ //未登录
                        if(item.rankingType == '3'){ //专题榜单
                            if(item.urlPc){
                                window.location.href = item.urlPc
                            }
                        }else{   // 非专题榜单

                            if(item.buyStatus){  //已购买榜单，进入详情
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }else{
                                this.ismodalshow = true
                                this.$refs.modaltoast.show({
                                    type:'guide',
                                    itemtype:'1',    //榜单
                                    itemdata:item
                                });
                            }
                        }




                        
                    }
                        
                   
                    
                break;
                    
            }
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
        handleScroll(){
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop, 
            clientHeight = document.documentElement.clientHeight || document.body.clientHeight, 
            scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight,
            height = 50; //根据项目实际定义

             // console.log('触发滚动：'+scrollTop+","+clientHeight+","+scrollHeight)
            if(scrollTop +clientHeight >= scrollHeight - height){
              if(this.currentpage > this.totalpage){
                return false
              }else{
                if(!this.isLoading){
                    this.currentpage ++ //显示条数新增
                    
                }
                

                if(this.currenttap == 'rank'){  //请求列表list 接口方法
                    this.getranklist()
                }else{
                    this.getreportlist()
                }
             
              } 
            }else{
              return false
            }
        },
        throttle(func, wait) {
            let lastTime = null
            let timeout
            return () => {
              let context = this;
              let now = new Date();
              let arg = arguments;
              if (now - lastTime - wait > 0) {
                if (timeout) {
                  clearTimeout(timeout)
                  timeout = null
                }
                func.apply(context, arg)
                lastTime = now
              } else if (!timeout) {
                timeout = setTimeout(() => {
                  func.apply(context, arg)
                }, wait)
              }
            }
        },
    }
}
</script>